import React from 'react'
import logoStyles from './logo.module.sass';
import Hoof from './Hoof'
export default class Logo extends React.Component {

  render() {
    const logoClasses = [logoStyles.figure]
    const {slug} = this.props

    if (slug === 'home' || slug === 'frequently-asked-questions' || !slug) {
      logoClasses.push(logoStyles.home);
    }
    return (
      <a className={logoClasses.join(' ')} href="/">
        <Hoof addClass={logoStyles.logo} />
        <strong className={[logoStyles.truffle, logoStyles.name].join(' ')}>Truffle</strong>
        <strong className={[logoStyles.pigs, logoStyles.name].join(' ')}>Pigs</strong>
        <strong className={logoStyles.date}>EST. 2000</strong>
      </a>
    );
  }

};